import BrowserFrame from "./BrowserFrame";
import PhoneFrame from "./PhoneFrame";

type Example = {
  name: string;
  tag: string;
  desc: string;
  overlayHeading: string;
  overlayTag: string;
  buttonLabel: string;
  image: string;
};

const EXAMPLES: Example[] = [
  {
    name: "新規サービス",
    tag: "事業紹介サイト",
    desc: "洗練された事業紹介サイト。伝えたい価値を、すっきりと。",
    overlayHeading: "新しいサービスを、はじめよう。",
    overlayTag: "Service Launch",
    buttonLabel: "サービスを見る",
    image: "/assets/sample-service.jpg",
  },
  {
    name: "期間限定企画",
    tag: "キャンペーンサイト",
    desc: "鮮やかで目を引く企画サイト。期間限定の熱量をそのままに。",
    overlayHeading: "夏の限定キャンペーン、開催中。",
    overlayTag: "Limited Campaign",
    buttonLabel: "キャンペーン詳細",
    image: "/assets/sample-campaign.jpg",
  },
  {
    name: "イベント",
    tag: "告知サイト",
    desc: "会場の雰囲気が伝わる告知サイト。参加したくなる印象を。",
    overlayHeading: "セミナー・相談会のお知らせ",
    overlayTag: "Event",
    buttonLabel: "参加申込",
    image: "/assets/sample-event.jpg",
  },
];

export default function Examples() {
  return (
    <section id="examples" className="scroll-mt-20 bg-white py-16 md:py-24">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="max-w-2xl">
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-lime-600">Design Image</p>
          <h2 className="mt-3 font-heading text-3xl font-black leading-tight text-navy-950 md:text-5xl">
            あなたの企画に、こんなホームページを。
          </h2>
        </div>

        <div className="mt-12 flex flex-col gap-16 md:gap-24">
          {EXAMPLES.map((example, i) => (
            <div
              key={example.name}
              className={`grid items-center gap-8 lg:grid-cols-2 lg:gap-12 ${
                i % 2 === 1 ? "lg:[&>*:first-child]:order-2" : ""
              }`}
            >
              <div>
                <div className="flex items-center gap-3">
                  <span className="flex h-10 w-10 items-center justify-center rounded-full bg-lime-400 font-heading text-lg font-black text-navy-950">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <div>
                    <p className="text-xs font-bold uppercase tracking-[0.15em] text-navy-400">
                      {example.tag}
                    </p>
                    <h3 className="font-heading text-2xl font-black text-navy-950 md:text-3xl">
                      {example.name}
                    </h3>
                  </div>
                </div>
                <p className="mt-5 max-w-sm text-base leading-relaxed text-navy-600">
                  {example.desc}
                </p>
              </div>

              <div className="relative">
                <BrowserFrame className="shadow-2xl shadow-navy-950/10">
                  <div className="relative">
                    <img
                      src={example.image}
                      alt={`${example.name}のサイト画面見本`}
                      title={`制作イメージ：${example.name}`}
                      loading="lazy"
                      className="h-60 w-full object-cover md:h-72"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-navy-950/80 via-navy-900/20 to-transparent" />
                    <div className="absolute inset-x-0 bottom-0 p-5 md:p-6">
                      <span className="inline-flex rounded-full bg-lime-400 px-2.5 py-1 text-[10px] font-bold uppercase tracking-wide text-navy-950">
                        {example.overlayTag}
                      </span>
                      <p className="mt-2 font-heading text-lg font-black text-white md:text-xl">
                        {example.overlayHeading}
                      </p>
                      <span className="mt-3 inline-block rounded-md bg-white px-3 py-1.5 text-xs font-bold text-navy-900">
                        {example.buttonLabel}
                      </span>
                    </div>
                  </div>
                </BrowserFrame>

                <span className="absolute -top-3 right-4 z-10 rounded-md bg-navy-900 px-2.5 py-1 text-[10px] font-bold uppercase tracking-wide text-lime-400">
                  デザインイメージ
                </span>

                <PhoneFrame className="absolute -bottom-6 -left-3 w-24 sm:-left-6 sm:w-28">
                  <img
                    src={example.image}
                    alt={`${example.name}のスマートフォン画面見本`}
                    title={`制作イメージ：${example.name}（スマートフォン）`}
                    loading="lazy"
                    className="h-40 w-full object-cover object-top sm:h-48"
                  />
                </PhoneFrame>
              </div>
            </div>
          ))}
        </div>

        <p className="mt-12 border-t border-navy-100 pt-6 text-sm text-navy-500">
          掲載している画面はデザインイメージです。実際の納品実績ではありません。
        </p>
      </div>
    </section>
  );
}
